<template>
  <div class="edit-button" v-if="$store.state.editing" v-on:click="handleClick"></div>
</template>

<script>
export default {
  methods: {
    handleClick: function () {
      this.$emit('click')
    }
  }
}
</script>

<style>

</style>
